import { CapacityUI } from './capacity-ui.js';

/**
 * Enough - Clean Capacity Tracker
 * Simple, beautiful capacity management inspired by the Enough app
 */
export class EnoughCapacity {
  constructor(container, dataManager, taskHub = null) {
    this.container = container;
    this.data = dataManager;
    this.taskHub = taskHub;

    // Initialize the UI module which handles everything else
    this.ui = new CapacityUI(container, dataManager, taskHub);
  }

  // Public API methods that delegate to the UI module
  refresh() {
    this.ui.refresh();
  }

  setOnTaskAdded(callback) {
    this.ui.setOnTaskAdded(callback);
  }

  setOnOpenPlanner(callback) {
    this.ui.setOnOpenPlanner(callback);
  }
}
